import { Modal } from 'antd';
import { trackPromise } from 'react-promise-tracker';
import { useOperationHook } from '../../../../../../hooks/useOperationHook';
import { IQuotationPriceDetail } from '../../../../../../model/EnquiryModal';
import { IManifestDetail, IReCalculateRequest, ManifestQuotationExtraCharges } from '../../../../../../model/OperationModel';
import { useOperationStore } from '../../../../../../stores/OperationStore';
import { CASH_ID, FREE_OF_COST, PRODUCT_TYPE } from '../../../../../../utils/app-common';
import { skipQuotation } from '../../../../../../utils/luxon';
import { useManifestContextHook } from '../Context/useManifestContextHook';
import { manifestQuotationExtraChargesRequest, quotationPriceDetailListRequest } from './SaveHook';


export const ValidateModal = () => {
    return Modal.error({
        title: 'Error',
        closable: true,
        content: 'Please select the Quotation',
        onCancel: () => Modal.destroyAll(),
        onOk: () => Modal.destroyAll()
    })
};

export const isQuotation = ({ isInternational, billTypeId, bookingDate, enquiryId }:
    { isInternational?: boolean, billTypeId?: number, bookingDate?: number, enquiryId?: number }) => isInternational && (billTypeId && (![CASH_ID].includes(billTypeId) || ![FREE_OF_COST].includes(billTypeId))) &&
    (skipQuotation(bookingDate) ? false : !enquiryId)
function RevalidateHook() {

    const ReCalculateManifestAction = useOperationStore((state) => state?.ReCalculateManifestAction);
    const manifestationList = useOperationStore((state) => state?.manifestationList);
    const selectedQuotation = useOperationStore((state) => state?.selectedQuotation);
    const { waybillNo, manifestQuote: manifestQuoteContext, manifestId, isInternational, billTypeId, product, consigneeUpdated } = useManifestContextHook();
    const { manifestQuote } = selectedQuotation || {};
    const { enquiryId, enquiryQuotationId } = manifestQuote ?? manifestQuoteContext ?? {};
    const { bookingDate } = useOperationHook();

    const performRevalidate = (form: any) => {
        const { getFieldValue } = form;
        const quotationPriceDetails: IQuotationPriceDetail[] = getFieldValue('quotationPriceDetailList');
        const { surCharge, ...rest } = manifestationList.manifetDetail! || {};
        const IRSExtraCharges = manifestQuotationExtraChargesRequest({ quotationPriceDetailList: quotationPriceDetails })
        const request: IReCalculateRequest = {
            ...manifestationList,
            waybillNo: waybillNo,
            destinationOdaCityId: +getFieldValue('destinationOdaCityId'),
            originOdaCityId: +getFieldValue('originOdaCityId'),
            destinationIsoda: Boolean(getFieldValue('destinationOdaCityId')),
            originIsoda: Boolean(getFieldValue('originIsoda')),
            multiDestinationCharges: +(getFieldValue('multiDestinationCharges')!),
            podCharges: +(getFieldValue('podCharges')!),
            podServiceDetails: +(getFieldValue('podServiceDetails')!),
            forkliftAmount: +(getFieldValue('forkliftAmount')!),
            labourCharges: +(getFieldValue('labourCharges')!),
            manifestQuote: {
                manifestId,
                enquiryQuotationId: enquiryId
            },
            manifetDetail: {
                ...rest,
                stdShipmentAmount: +getFieldValue('stdShipmentAmount'),
                originOdaCharge: +getFieldValue('originOdaCharge'),
                destOdaCharge: +getFieldValue('destOdaCharge'),
                podCharges: +getFieldValue('podCharges'),
                labourCharges: +getFieldValue('labourCharges'),
                insuranceCharges: +getFieldValue('insuranceCharges'),
                insuranceValue: +getFieldValue('insuranceValue'),
                insurancePercentage: +getFieldValue('insurancePercentage'),
                forkliftAmount: +getFieldValue('forkliftAmount'),
                additionalWeight: +getFieldValue('additionalWeight'),
                manualFreightCharges: +(getFieldValue('manualFreightCharges')),
                otherCharges: +(getFieldValue('otherCharges')),
                otherCharges3: +(getFieldValue('otherCharges3')),
                otherCharges4: +(getFieldValue('otherCharges4')),
                otherCharges5: +(getFieldValue('otherCharges5')),
                // otherCharge3: +(getFieldValue('otherCharge3')),
                // otherCharge2: +(getFieldValue('otherCharge2')),
                // otherCharge1: +(getFieldValue('otherCharge1')),
                demurrageCharge: +(getFieldValue('demurrageCharge')),
                remarks: getFieldValue('remarks'),
                internationalNetAmount: +getFieldValue('internationalNetAmount'),
                internationalVatPercentage: +getFieldValue('internationalVatPercentage'),
                internationalVatAmount: +getFieldValue('internationalVatAmount'),
                internationalGrossAmount: +getFieldValue('internationalGrossAmount'),
                domesticGrossAmount: +getFieldValue('domesticGrossAmount'),
                totalNetAmount: +getFieldValue('totalNetAmount'),
                totalGrossAmount: +getFieldValue('totalGrossAmount'),
                originOdaChargeExempt: +getFieldValue('originOdaChargeExempt'),
                destinationOdaChargeExempt: +getFieldValue('destinationOdaChargeExempt'),
                oversizeShipmentCharge: +getFieldValue('oversizeShipmentCharge'),
                waitingCharge: +getFieldValue('waitingCharge'),
                consigneeCharges: +getFieldValue('consigneeCharges'),
                ...quotationPriceDetailListRequest({ quotationPriceDetailList: quotationPriceDetails }),
            } as IManifestDetail,

            manifestQuotationExtraCharges: Object.entries(IRSExtraCharges)?.length ? {
                ...IRSExtraCharges,
                enquiryQuotation: enquiryQuotationId,
                enquiryQuotationId: enquiryId,
                manifestId,
            } as ManifestQuotationExtraCharges : undefined,
        };
        const { priceDetailList, quotationPriceDetailList, ...requestRest } = request;
        trackPromise(ReCalculateManifestAction({ waybillNo, request: requestRest }), 'button-click-area')
    }

    const reValidateHandle = (form: any) => {
        if (isQuotation({ isInternational, billTypeId, bookingDate, enquiryId })) {
            if (product && ![PRODUCT_TYPE.INTERNATIONAL_ROAD_EXPRESS, PRODUCT_TYPE.INTERNATIONAL_ROAD_PALLETS].includes(product as PRODUCT_TYPE)) {
                ValidateModal()
                return;
            }
        }
        if (consigneeUpdated && +(form?.getFieldValue('consigneeCharges') ?? 0) === 0) {
            Modal.confirm({
                title: 'Consignee Address Change',
                content: 'Consignee address updated. Do you want to proceed with 0 as the charge?',
                okText: 'Yes',
                cancelText: 'Cancel',
                onOk: () => performRevalidate(form)
            });
            return;
        }
        performRevalidate(form);
    }
    return { reValidateHandle }
}

export default RevalidateHook